import React, { Component } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@mui/material';
import i18n from '../../../i18n';
import Details from '../../details';
import { adaptedName } from '../../../utils/dataHelpers';

class DetailsDialogAbstract extends Component {
    Head;
    permissions = {};
    constructor(props) {
        super(props);
        this.Head = props.Head;
        this.permissions = props.context.getState().permissions;
    }
    allowedPermission = (action, controller) => {
        const adaptedController = adaptedName(controller);
        const permission = Object.keys(this.permissions).length
            ? this.permissions?.[adaptedController]?.[action]
            : '';
        return permission !== 'deny';
    };
    //props: open, onClose, data, Head
    render() {
        const { data } = this.props;
        return (
            <Dialog
                open={this.props.open}
                onClose={() => this.props.onClose()}
                maxWidth={'sm'}
                fullWidth={true}
            >
                <DialogTitle>{i18n.t('common.showDetails')}</DialogTitle>
                <DialogContent>
                    {this.Head.some((f) => {
                        return data[f.id]; // Check if any field has a value
                    }) ? (
                            this.Head.filter((f) =>
                                f.from
                                    ? this.allowedPermission('read', f.from)
                                    : true
                            ).map((field) => {
                                let Field = Details[field.details];
                                let value = data[field.id];
                                if (field.object && data[field.object]) {
                                    value = data[field.object][field.id] || null;
                                    console.log('value', value);
                                }
                                if (!Field) return null;
                                return (
                                    <Field
                                        key={field.id}
                                        label={field.label}
                                        value={value}
                                        context={this.props.context}
                                    />
                                );
                            })
                        ) : (
                            <div>{i18n.t('common.notAvailableDetails')}</div>
                        )}
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => this.props.onClose()}
                        color="primary"
                    >
                        {i18n.t('common.close')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default DetailsDialogAbstract;
